export const entityLabelMap: Record<string, string> = {
  ADMINISTRADORAS: "Administradoras",
  AUTHENTICATION: "Autenticação",
  BORDERO: "Parcelas",
  CHECKOUT_PAYMENT: "Pagamento",
  COMISSAO_CORRETORA: "Comissão Corretora",
  COMISSAO_PRODUTOR: "Comissão Produtor",
  COMISSOES_ADMINISTRADORA: "Comissões Administradora",
  COMPANY: "Empresa",
  CONTA_CORRENTE: "Conta Corrente",
  CONTA_CORRENTE_ITENS_ABERTO: "Itens em Aberto",
  CONTA_CORRENTE_PARCELAS_BORDERO: "Parcelas Borderô",
  CONTRATOS: "Contratos",
  EMAIL_LOGS: "Logs de Email",
  EMPRESAS: "Empresas",
  ERRORS: "Erros",
  FILES: "Arquivos",
  FILIAIS: "Filiais",
  GRUPOS_IMPOSTO: "Grupos de Imposto",
  IMPOSTO_GLOBAL: "Imposto Global",
  LOGINS: "Logins",
  LOGS: "Logs",
  LOGS_ERROS: "Logs de Erros",
  LOGS_NEW: "Logs do Sistema",
  METRICS: "Métricas",
  MODALIDADES: "Modalidades",
  OPERADORAS: "Operadoras",
  PARTNERSHIP: "Parcerias",
  PERMISSIONS: "Permissões",
  PRODUTORES: "Produtores",
  RECOVER_PASSWORD: "Recuperação de Senha",
  REPOSITORIES_OPERATORS_LAYOUT: "Layout Operadoras",
  ROOT: "Sistema",
  SUBSCRIPTION_STRIPE: "Assinatura",
  TEMPLATES_EMAIL_CONFIG: "Templates de Email",
  TIPO_PRODUTOR: "Tipo de Produtor",
  TYPE_COMMISSIONS_UPLOAD: "Upload de Comissões",
  USUARIOS: "Usuários",
  UTILS: "Utilitários",
};

export const actionLabelMap: Record<string, string> = {
  CREATE: "Criação",
  UPDATE: "Atualização",
  DELETE: "Remoção",
  GET: "Consulta",
  LIST: "Consulta de Itens",
  GET_DISTINCT: "Consulta",
  LOGIN: "Login",
  "LOGIN::": "Login",
  Login: "Login",
  IMPORT: "Importação",
  EXPORT: "Exportação",
  CANCEL: "Cancelamento",
  APPROVE: "Aprovação",
  REJECT: "Rejeição",
  PUT: "Atualização",
  PATCH: "Atualização",
  RECEIVE: "Recebimento",
  RESTORE: "Restauração",
};

export const getEntityLabel = (entity?: string) => {
  return entityLabelMap[entity || ""] || entity || "-";
};

export const getActionLabel = (action?: string) => {
  const normalized = String(action || "").toUpperCase();
  return actionLabelMap[normalized] || action || "-";
};

export const getActionColor = (action?: string) => {
  const normalized = String(action || "").toUpperCase();

  if (["CREATE", "APPROVE", "RESTORE"].includes(normalized)) return "success";
  if (["UPDATE", "PATCH", "PUT"].includes(normalized)) return "warning";
  if (["DELETE", "REJECT", "CANCEL"].includes(normalized)) return "error";
  if (["GET", "LIST", "GET_DISTINCT"].includes(normalized)) return "info";

  return "default";
};

export const getUniqueActions = (actions: string[]) => {
  const seen = new Set<string>();

  return actions.filter((action) => {
    const label = getActionLabel(action);

    if (seen.has(label)) return false;

    seen.add(label);
    return true;
  });
};
